<template>
    <Modal2
        id="awaiting-message-details"
        :title="$t('message.historyDetails')"
        :show-footer="false"
        @cancel="closeModal"
    >
        <b-tabs content-class="mt-3" id="ticket-response">
            <b-tab :title="$t('message.chat')" active>
                <div v-if="selectedHistory.type === 'osr'">
                    <p class="p-2">{{ selectedHistory.messages }}</p>
                    <quill-editor v-model="responseText" :options="editorOption" />
                    <b-row class="mt-4">
                        <b-col md="12">
                            <SupsisButton @click="closeModal" ghost class="float-right">
                                <template>
                                    {{ $t("message.cancel") }}
                                </template>
                            </SupsisButton>
                            <SupsisButton
                                @click="sendResponse"
                                primary
                                :disabled="responseSending"
                                class="float-right mr-2"
                            >
                                <template v-if="!responseSending">
                                    {{ $t("message.send") }}
                                </template>

                                <template v-else>
                                    <font-awesome-icon icon="spinner" spin />
                                    {{ $t("message.sending") }}...
                                </template>
                            </SupsisButton>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <div v-if="filteredMessages.length" style="display: flex; flex-direction: column">
                        <div v-if="filteredMessages.length" v-chat-scroll class="waiting-ticket-messages">
                            <MessageList
                                :contextMenuVisable="false"
                                :always-scroll-to-bottom="false"
                                :colors="colors"
                                :messages="getMessages()"
                                :participants="getParticipants()"
                            />
                        </div>
                        <quill-editor v-model="responseText" :options="editorOption" />
                        <div class="actions">
                            <SupsisButton @click="closeModal" ghost>
                                {{ $t("message.cancel") }}
                            </SupsisButton>

                            <SupsisButton
                                @click="sendResponse"
                                primary
                                :disabled="responseSending"
                                v-if="!['instagram-comment', 'page-comment'].includes(ticket.type)"
                            >
                                <span v-if="responseSending">
                                    <font-awesome-icon icon="spinner" spin />
                                    {{ $t("message.sending") }}...
                                </span>
                                <span v-else>{{ $t("message.send") }}</span>
                            </SupsisButton>
                            <SupsisButton
                                @click="() => sendAsComment(false)"
                                primary
                                :disabled="responseSending"
                                v-if="['instagram-comment', 'page-comment'].includes(ticket.type)"
                            >
                                <span v-if="responseSending">
                                    <font-awesome-icon icon="spinner" spin />
                                    {{ $t("message.sending") }}...
                                </span>
                                <span v-else>{{ $t('message.replyAsAComment') }}</span>
                            </SupsisButton>
                            <SupsisButton
                                @click="() => sendAsComment(true)"
                                primary
                                :disabled="responseSending"
                                v-if="['instagram-comment', 'page-comment'].includes(ticket.type)"
                            >
                                <span v-if="responseSending">
                                    <font-awesome-icon icon="spinner" spin />
                                    {{ $t("message.sending") }}...
                                </span>
                                <span v-else>{{ $t('message.ReplyAsAPm') }}</span>
                            </SupsisButton>
                        </div>
                    </div>
                    <div v-else>
                        <b-alert show variant="info">{{ $t("message.chatNotFound") }}</b-alert>
                    </div>
                </div>
            </b-tab>
            <b-tab v-if="!!isVisitorExist()" :title="$t('message.visitorInfo')">
                <div class="userInfo">
                    <div class="userInfo first">
                        {{ $t("message.fullName") }}
                    </div>
                    <div class="userInfo sec">
                        {{ visitorInfo.fullname }}
                    </div>
                </div>
                <div class="userInfo">
                    <div class="userInfo first">
                        {{ $t("message.email") }}
                    </div>
                    <div class="userInfo sec">
                        {{ visitorInfo.email }}
                    </div>
                </div>
                <div class="userInfo">
                    <div class="userInfo first">
                        {{ $t("message.phone") }}
                    </div>
                    <div class="userInfo sec">
                        {{ visitorInfo.phone }}
                    </div>
                </div>
                <div class="userInfo">
                    <div class="userInfo first">IP</div>
                    <div class="userInfo sec">
                        {{ ticket.visitor.ipAddress || "-" }}
                    </div>
                </div>
                <div class="userInfo">
                    <div class="userInfo first">
                        {{ $t("message.browser") }}
                    </div>
                    <div class="userInfo sec">
                        {{ ticket.visitor.browser || "-" }}
                    </div>
                </div>
                <div class="userInfo">
                    <div class="userInfo first">{{ $t("message.os") }}</div>
                    <div class="userInfo sec">
                        {{ ticket.visitor.os || "-" }}
                    </div>
                </div>
            </b-tab>
        </b-tabs>
    </Modal2>
</template>
<script>
import Modal2 from "../../../../components/common/Modal2.vue";
import MessageList from "../../../../components/popup-chat/MessageList.vue";
import * as _ from "lodash";
import moment from "moment/moment";
import { toNewMessagesModel } from "../../../../utils/chat";
import SupsisButton from "../../Settings/components/SupsisButton.vue";
import ticket from "../../../../store/modules/ticket";
import { mapActions } from "vuex";

export default {
    name: "AwatingTicketDetails",
    components: { SupsisButton, MessageList, Modal2 },
    props: ["ticket"],
    data: () => ({
        responseText: null,
        selectedHistory: {
            visitor: {},
            messages: [],
            ticket: {},
            type: null,
        },
        responseSending: false,
        colors: {
            header: {
                bg: "#4e8cff",
                text: "#ffffff",
            },
            launcher: {
                bg: "#4e8cff",
            },
            messageList: {
                bg: "#ffffff",
            },
            sentMessage: {
                bg: "#4e8cff",
                text: "#ffffff",
            },
            receivedMessage: {
                bg: "#eaeaea",
                text: "#222222",
            },
            userInput: {
                bg: "#f4f7f9",
                text: "#565867",
            },
        },
        editorOption: {
            theme: "snow",
            modules: {
                toolbar: [
                    ["bold", "italic", "underline", "strike"],
                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                    [{ color: [] }, { background: [] }],
                    [{ align: [] }],
                    [{ indent: "-1" }, { indent: "+1" }],
                    ["link"],
                ],
            },
        },
    }),
    computed: {
        visitorInfo() {
            if (!this.isVisitorExist())
                return {
                    email: "-",
                    fullname: "-",
                };
            if (this.selectedHistory.type === "osr") return this.selectedHistory.ticket.osrPayload;
            if (!!this.selectedHistory.visitor.email && !!this.selectedHistory.visitor.fullname)
                return this.selectedHistory.visitor;
            if (
                !!this.selectedHistory.ticket.conversation &&
                !!this.selectedHistory.ticket.conversation.email &&
                !!this.selectedHistory.ticket.conversation.fullname
            )
                return this.selectedHistory.ticket.conversation;
            return {
                email: "-",
                fullname: "-",
            };
        },
        filteredMessages() {
            return this.selectedHistory.messages.filter((m) => "undefined" === typeof m.type);
        },
    },
    methods: {
        ...mapActions({
            loadOldMessages: "chat/loadOldMessages",
        }),
        closeModal() {
            this.$emit("close");
        },
        sendResponse() {
            this.$emit("confirm", {
                selectedHistory: this.selectedHistory,
                responseText: this.responseText,
            });
            this.responseText = "";
        },
        getMessages() {
            let allMessages = toNewMessagesModel(this.filteredMessages, this);
            if (this.typingMessage) {
                allMessages = [
                    ...allMessages,
                    {
                        type: "typing",
                        data: {
                            text: this.typingMessage,
                        },
                    },
                ];
            }

            return allMessages;
        },
        init() {
            const ticketMessages = JSON.parse(localStorage.getItem("savedTicketMessages") || "{}");
            this.responseText = ticketMessages[this.ticket._id] || "";
            this.selectedHistory.ticket = this.ticket;
            this.selectedHistory.visitor = this.ticket.visitor;
            if (!!this.ticket.osrPayload) {
                this.selectedHistory.messages = this.ticket.osrPayload.message;
                this.selectedHistory.type = "osr";
            } else {
                this.loadOldMessages(this.ticket.conversation._id).then((response) => {
                    let items = response.data.data;
                    items = _.orderBy(
                        _.uniqBy(items, (q) => q.uniqMessageId || q._id),
                        (q) => moment(q.createdDate).toDate().getTime(),
                        "asc"
                    );
                    this.selectedHistory.messages = items;
                });
            }
        },
        getParticipants() {
            const supportUsers = this.filteredMessages
                .filter((x) => x.messageType === "user" || x.messageType === "private")
                .map((x) => ({
                    id: x.userId,
                    name: x.username,
                }));

            return _.uniqBy(supportUsers, (q) => q.name);
        },
        isVisitorExist() {
            const visitor = _.get(this.selectedHistory, "visitor", {}) || {};
            const visitorKeys = Object.keys(visitor);
            return visitorKeys.length || [].length;
        },
        sendAsComment(isPrivate = false) {
            this.$emit("sendAsComment", {
                selectedHistory: this.selectedHistory,
                responseText: this.responseText,
                isPrivate,
            });
            this.responseText = "";
        },
        saveLocaleStore: _.debounce(function () {
            const ticketMessages = JSON.parse(localStorage.getItem("savedTicketMessages") || "{}");
            localStorage.setItem(
                "savedTicketMessages",
                JSON.stringify({
                    ...ticketMessages,
                    [this.ticket._id]: this.responseText,
                })
            );
        }, 200),
    },
    watch: {
        responseText() {
            this.saveLocaleStore();
        },
    },
    mounted() {
        this.init();
    },
};
</script>
